import { Component, OnInit } from '@angular/core';

import { ArkUnitOfWork } from 'app/core/core.module';
import { Interest } from 'app/core/model/entity-model';
import { SharedModule } from 'app/shared/shared.module';
import { Predicate } from 'breeze-client';
import { DevExtremeModule } from 'devextreme-angular';

@Component({
    selector: 'app-view',
    templateUrl: './view.component.html',
    styleUrls: ['./view.component.scss'],
    imports: [DevExtremeModule]
})
export class ViewComponent implements OnInit {
    interests: any[];
    people: any;
    selectedInterest: any;

    constructor(private uow: ArkUnitOfWork) {}

    async ngOnInit() {
        const interests = await this.uow.interests.whereActive('interestCategory.displayOrder,displayOrder', 'interestCategory');
        this.interests = interests.map(i => {
            return { id: i.id, name: i.interestCategory.name + ' - ' + i.name };
        });
    }

    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift({
            location: 'before',
            template: 'toolbarButtons'
        });
    }

    async selectedInterestChanged(e) {
        if (!this.selectedInterest) return;
        this.people = await this.uow.interests.getPeopleWithInterest(this.selectedInterest.id);
    }
}
